import VideoPlayer from "./VideoPlayer";
import "./index.scss";
import Section from "@components/Section";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import { useKeyup } from "@hooks/utils";
import { hideVideoDisplay } from "@store/globalVideoSlice";
import { createPortal } from "react-dom";
import { useEffect } from "react";
import UploadImage from "@components/UploadImage";
import { Trans } from "react-i18next";
import NoIconDownload from "./VideoPlayer/icon-download.svg?react";
import NoIconExport from "./VideoPlayer/icon-export.svg?react";
import NoIconClose from "./VideoPlayer/icon-close.svg?react";
import { useVideoURL } from "@hooks/useVideoURL";

const VideoMask = () => {
  const dispatch = useAppDispatch();
  const {
    videoDisplay,
    videoId,
    videoURL: OriginalVideoURL,
    videoSource,
    aspectRatio,
  } = useAppSelector((state) => state.globalVideoReducer);

  const isHorizontal = aspectRatio === "RATIO_16_9";

  if (videoDisplay) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "overlay";
  }

  useKeyup(() => {
    dispatch(hideVideoDisplay());
  });

  const { videoURL, setVideoURL, requestVideoURL } = useVideoURL();
  useEffect(() => {
    if (OriginalVideoURL) {
      setVideoURL({
        data: OriginalVideoURL,
        status: "succeeded",
        error: null,
      });
    } else if (videoId) {
      requestVideoURL(videoId, videoSource);
    }
  }, [videoId, OriginalVideoURL, videoSource]);

  if (videoDisplay) {
    return createPortal(
      <div className="relative">
        <div className="absolute top-0 left-0 -translate-y-full translate-x-[0%] z-1000 w-full h-screen bg-black/50 backdrop-blur-md"></div>
        <div className="Layout-VideoMask">
          <div className={isHorizontal ? "video video--ratio-16-9" : "video"}>
            <Section
              ErrorComponent={
                videoURL.status === "failed" ? (
                  <>
                    <div
                      className="bg-[#F1F1F1] p-px rounded flex items-center justify-center gap-1 flex-col px-[36px]"
                      style={{ width: "100%", height: "100%" }}
                    >
                      <UploadImage name="c1eda846.png" className="w-[160px] h-[160px]"></UploadImage>
                      <span className="text-kds-fg-subtle text-[14px] text-center">
                        <Trans>This video has been removed or hidden.</Trans>
                      </span>
                    </div>

                    <div>
                      <div className="flex flex-col gap-[24px] absolute top-0 left-[372px]">
                        <div
                          className="w-[40px] h-[40px] rounded-full bg-[#999] cursor-pointer flex items-center justify-center"
                          onClick={() => dispatch(hideVideoDisplay())}
                        >
                          <NoIconClose className="w-6 h-6"></NoIconClose>
                        </div>
                        <div className="flex flex-row items-center gap-[8px]">
                          <div className="w-[40px] h-[40px] rounded-full bg-[#999] flex items-center justify-center shrink-0">
                            <NoIconDownload className="w-6 h-6"></NoIconDownload>
                          </div>
                          <div className="text-[12px] text-white whitespace-nowrap">
                            <Trans>Download Video (Without Watermark)</Trans>
                          </div>
                        </div>
                        <div className="flex flex-row items-center gap-[8px]">
                          <div className="w-[40px] h-[40px] rounded-full bg-[#999] flex items-center justify-center shrink-0">
                            <NoIconExport className="w-6 h-6"></NoIconExport>
                          </div>
                          <div className="text-[12px] text-white whitespace-nowrap">
                            <Trans>Export Script</Trans>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )
              }
              status={videoURL.status}
              reload={() => videoId && requestVideoURL(videoId, videoSource)}
            >
              <VideoPlayer videoURL={videoURL.data}></VideoPlayer>
            </Section>
          </div>
        </div>
      </div>,
      document.body,
    );
  }
  return null;
};

export default VideoMask;
